import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const splitCamelCase = (s: string) =>
  s
    .replace(
      /^[a-z]|^([A-Z]+)(?=[A-Z]|$)|([A-Z])+(?=[A-Z]|$)|([A-Z])(?=[a-z]+)/g,
      (m) => ' ' + m.toUpperCase()
    )
    .trim()

export function capitalizeFirstChar(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function stripUrl(url: string) {
  return url.replace(/(https?:\/\/)?(www\.)?/g, '')
}
